import { useCRUD } from 'lib/swr-crud';
import { getCatalogueByIdOrSlug } from './api';
import { Catalogue } from './types';

const useCatalogue = (catalogueId: number | string) => {
  const { data, error, mutate, isLoading } = useCRUD(
    `/catalogues/${catalogueId}`,
    async () => {
      return getCatalogueByIdOrSlug(catalogueId);
    },
  );

  const catalogue: Catalogue | undefined = data;

  return {
    catalogue,
    error,
    isLoading,
    mutate,
  };
};

export default useCatalogue;
